(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-labor-day-page]';
  const BODY_CLASS = 'icarsoft-labor-day-page-active';

  const syncThemeChrome = () => {
    const shouldHide = Boolean(document.querySelector(ROOT_SELECTOR));
    document.body.classList.toggle(BODY_CLASS, shouldHide);
  };

  const fallbackCopy = (value) => {
    const input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    const copied = document.execCommand('copy');
    input.remove();
    return copied;
  };

  const copyValue = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return true;
    }
    return fallbackCopy(value);
  };

  const initRoot = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.laborInitialized === 'true') return;
    root.dataset.laborInitialized = 'true';

    root.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-copy-code]');
      if (!button || !root.contains(button)) return;

      const code = button.dataset.copyCode || '';
      const status = button.querySelector('[data-copy-status]');
      const originalStatus = status ? status.textContent : '';

      try {
        const copied = await copyValue(code);
        if (!copied) throw new Error('Copy command was not available.');
        button.classList.add('isCopied');
        if (status) status.textContent = root.dataset.copiedLabel || 'COPIED';
      } catch (error) {
        if (status) status.textContent = root.dataset.copyFailedLabel || 'COPY MANUALLY';
      }

      window.setTimeout(() => {
        button.classList.remove('isCopied');
        if (status) status.textContent = originalStatus;
      }, 1800);
    });
  };

  const initAll = (scope = document) => {
    if (scope instanceof Element && scope.matches(ROOT_SELECTOR)) initRoot(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initRoot);
    syncThemeChrome();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', () => window.setTimeout(syncThemeChrome, 0));
})();
